<template>
    <div>
        <b-container fluid class="mt--7">
            <location-list
                v-if="isList"
                title="Locations Management"
                :loading="loading"
                ref="table"
            >
            </location-list>
            <location-view
                v-else
                :id="id"
                :loading="loading"
                @save-location="saveLocation"
                @delete-section="deleteSection"
                @save-section="saveSection"
                @delete-location="deleteLocation"
            />
        </b-container>
    </div>
</template>
<script>
import LocationList from './LocationList'
import LocationView from './LocationView'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import showItemHelper from '@/mixins/showItemHelper'

const noneError = 'NoneError'
const invalidNameError = 'InvalidName'

export default {
    name: 'locations',
    components: {
        LocationList,
        LocationView,
    },
    mixins: [popupMixins, permissionsMixins, showItemHelper],
    data: () => {
        return {
            loading: false,
            componentName: 'Location',
        }
    },

    methods: {
        async saveLocation(payload) {
            try {
                this.loading = true
                const id = payload.id
                delete payload.id
                const path = id ? 'locations/update' : 'locations/create'
                const action = id ? 'Updated' : 'Created'
                const type = 'success'
                await this.$store.dispatch(path, { id, payload })

                this.genericToast( 
                    this.componentName,
                    action,
                    type,
                    `Location has been successfully ${action.toLowerCase()}`
                )
                //this.doToast('Success!', title, type)
                this.$router.go(-1)
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.loading = false
            }
        },

        /**
         * Stores the section data
         */
        async saveSection({ section, location_id }) {
            try {
                this.loading = true
                console.log('section', section)
                console.log('location_id', location_id)
                const { id, name, is_officer } = section

                // Check if the Section is empty
                if (!/^[a-z][a-z\d\-_\s]+$/i.test(name)) {
                    throw invalidNameError
                }
                // const { id: location_id } = this.item
                const payload = { name, is_officer }
                const path = id
                    ? 'locations/updateSection'
                    : 'locations/createSection'

                await this.$store.dispatch(path, {
                    location_id,
                    id,
                    payload,
                })

                console.log('Location is ', this.locationSections)

                this.genericToast(this.componentName,'Created','success',`${this.componentName} Section successfully created`)
                // this.doToast(
                //     'Success!',
                //     'Location Section Successfully Saved',
                //     'success'
                // )

                // Catch all block for unhandled errors
            } catch (error) {
                console.error('saveSection', (error && error.message) || error)
                if (error === invalidNameError) {
                    this.doToast(
                        'Error!',
                        'Invalid Name.  Please enter a valid name of the Location Section',
                        'danger'
                    )
                } else {
                    this.doToast('Error!', 'Unable to store section.', 'danger')
                }
            } finally {
                this.loading = false
                this.$forceUpdate()
            }
        },

        async deleteLocation(id) {
            try {
                this.loading = true
                const result = await this.confirmMessage(
                    'Delete Location?',
                    `Are you sure you want to delete the Location?`
                )

                if (!result) {
                    throw noneError
                }

                await this.$store.dispatch('locations/delete', id)

                this.genericToast(this.componentName,'Deleted','success',`${this.componentName} successfully deleted `)
                // this.doToast(
                //     'Deleted!',
                //     'Location has been deleted.',
                //     'success'
                // )

            } catch (error) {
                console.error(error)
                if (error != noneError) {
                    this.doToast(
                        'Error!',
                        'Unable to delete Location! There is an association with this location',
                        'danger'
                    )
                }
            } finally {
                this.loading = false
                this.$router.go(-1)
            }
        },

        async deleteSection({ id, location_id }) {
            try {
                this.loading = true
                const result = await this.confirmMessage(
                    'Delete Location Section?',
                    `Are you sure you want to delete this Location Section?`
                )

                if (!result) {
                    throw noneError
                }
                await this.$store.dispatch('locations/deleteSection', {
                    id,
                    location_id,
                })

                this.genericToast(this.componentName,'Deleted','success',`${this.componentName} Section successfully deleted`)
                // this.doToast(
                //     'Deleted!',
                //     'Location Section has successfully been deleted.',
                //     'success'
                // )


            } catch (error) {
                console.log('error message', error)
                if (error != noneError) {
                    const message =
                        'Cannot Delete Section. There are associations with this Location Section'
                    this.doToast('Error!', message, 'danger')
                }
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
<style></style>
